import React,{useContext,useState,useCallback,useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import './LeftPanel.css'
import api from '../contexts/BaseUrl'
import HomeIcon from '../icons/HomeIcon'
import PurchaseIcon from '../icons/PurchaseIcon'
import ProductionIcon from '../icons/ProductionIcon'
import DollarIcon from '../icons/SalesIcon'
import SettingsIcon from '../icons/SettingsIcon';
import StockIcon from '../icons/StockIcon';
import LogoutIcon from '../icons/LogoutIcon';
import { UnitShadeContext } from "../contexts/UnitShadeContext";
import MarketDueIcon from '../icons/MarketDueIcon';

const LeftPanel = (props) =>{
    const {tabName} = props;
    const navigate = useNavigate();

    const { unitShadeNo, setUnitShadeNo } = useContext(UnitShadeContext);
    const [allUnitShades,setAllUnitShades] = useState([]);
    const token = JSON.parse(localStorage.getItem('auth')).token;

    const fetchAllUnitShades = useCallback( async () => {
        await api.get(`unitShades/get-all-unit-shades`,{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setAllUnitShades(response.data);
        })
    },[token])

    useEffect(() => {
        fetchAllUnitShades();
    },[fetchAllUnitShades])

    const handleLogout = () => {
        localStorage.removeItem('auth');
        navigate('/login')
    }

    return(
        <div className='leftPanel'>
            <div id='headerText'>Porichorja</div>
            <div id='headerTextRed'>Crop</div>

            <select 
                required 
                id='chooseBox'
                onChange={(e) => setUnitShadeNo(Number(e.target.value))}
                value={unitShadeNo}
            >
                <option value="">Choose Shade</option>
                {allUnitShades.map(item => (
                    <option key={item.unitShadeId} value={item.unitShadeId}>{item.unitShadeName}</option>
                ))}
            </select>


            <Link 
                to='/'
                className='homeTabBox'
                style={tabName==='home' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='home' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                <HomeIcon 
                    size={24} 
                    style={{marginTop:7,marginLeft: tabName === 'home' ? 25 : 30}} 
                    
                />
                <div className='tabText' 
                    style={tabName==='home' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Home</div>
            </Link> 
            <Link 
                to = '/sales'
                className='purchaseTabBox'
                style={tabName==='sales' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='sales' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                 <MarketDueIcon 
                    size={24} 
                    style={{marginTop:10, marginLeft:tabName === 'sales' ? 25:30}} 
                    
                />
                <div className='dailyExpenseTabText' 
                    style={tabName==='Sales' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Sales</div>
            </Link>
            <Link 
                to = '/daily-expense'
                className='purchaseTabBox'
                style={tabName==='daily-expense' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='daily-expense' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                 <DollarIcon 
                    size={24} 
                    style={{marginTop:10, marginLeft:tabName === 'daily-expense' ? 25:30}} 
                    
                />
                <div className='dailyExpenseTabText' 
                    style={tabName==='daily-expense' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Daily Expense</div>
            </Link>
            <Link 
                to='/materials-expense'
                className='purchaseTabBox'
                style={tabName==='materials-expense' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='materials-expense' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                    <StockIcon 
                        size={22} 
                        style={{marginTop:10,marginLeft:tabName === 'materials-expense' ? 25 : 30, marginRight:5}} 

                    /> 
                <div className='materialsExpenseTabText' 
                    style={tabName==='materials-expense' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Materials Expense</div>
            </Link>
            <Link 
                to='/labor-expense'
                className='purchaseTabBox'
                style={tabName ==='labor-expense' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='labor-expense' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                <PurchaseIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft: tabName === 'labor-expense' ? 25 : 30}} 
                />
                <div className='tabText' 
                    style={tabName==='labor-expense' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Labor Expense</div>
            </Link>
            <Link 
                to='/other-expenses'
                className='purchaseTabBox'
                style={tabName ==='other-expenses' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='other-expenses' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                <ProductionIcon 
                    size={24} 
                    style={{marginTop:8,marginLeft: tabName === 'other-expenses' ? 25 : 30}} 
                />
                <div className='tabText' 
                    style={tabName==='other-expenses' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Other Expenses</div>
            </Link>
            
            
            
            <Link 
                to='/settings'
                className='purchaseTabBox'
                style={tabName==='settings' ?
                {
                    backgroundColor:'#e7e5ff'
                }:{
                    backgroundColor:'white'
                }}
            >
                {tabName ==='settings' &&
                    <div style={{ width: 5, height: 45, backgroundColor: '#978CF3' }} />                
                }
                <SettingsIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft: tabName === 'settings' ? 25 : 30}} 
                    color='black'
                />
                <div className='tabText' 
                    style={tabName==='settings' ? {fontFamily:'LexendBold' }:{fontFamily:'LexendMedium'}}
                >Settings</div>
            </Link>
            
            <div className='logoutIcon' onClick={handleLogout}>
                <LogoutIcon size={70} style={{marginLeft:15}} />
                <div id='logoutText'>Logout</div>
            </div>
            
        </div>
    )
}

export default LeftPanel;